"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _CircularProgress = _interopRequireDefault(require("@mui/material/CircularProgress"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Typography = _interopRequireDefault(require("@mui/material/Typography"));
var _SNETDialog = _interopRequireDefault(require("shared/dist/components/SNETDialog"));
var _styles = require("./styles");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const SNETLoader = _ref => {
  let {
    isLoading,
    title = "Please, wait",
    content
  } = _ref;
  const classes = (0, _styles.useStyles)();
  return /*#__PURE__*/_react.default.createElement(_SNETDialog.default, {
    isDialogOpen: isLoading,
    title: title,
    showCloseButton: false,
    children: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
      className: classes.circularProgressContainer
    }, /*#__PURE__*/_react.default.createElement(_CircularProgress.default, {
      className: classes.circularProgress
    })), /*#__PURE__*/_react.default.createElement(_Typography.default, {
      className: classes.loaderContent,
      variant: "body2",
      component: "p"
    }, content)),
    contentClass: classes.card
  });
};
SNETLoader.propTypes = {
  isLoading: _propTypes.default.bool.isRequired,
  title: _propTypes.default.string.isRequired,
  content: _propTypes.default.string
};
var _default = exports.default = SNETLoader;